<script setup lang="ts">
import { t } from "../../i18n";
import AppModal from "../common/AppModal.vue";
</script>

<template>
    <AppModal class="order-modal" name="order" :title="t('modal.order.order')">
        <span v-html="t('modal.order.sent')"></span>
    </AppModal>
</template>
